// type of places in DU
enum place_types {
  // campus
  department = 'department',
  office = 'office',
  hall = 'hall',
  canteen = 'canteen',
  copier = 'copier',
  hostel = 'hostel',
  theatre = 'theatre',
  // transport
  bus_stop = 'bus stop',
  station = 'station',
  // activity
  activity = 'activity',
  library = 'library',
  stadium = 'stadium',
  herbarium_house = 'herbarium house',
  rc = 'rc',
  atm = 'atm',
  // others
  other = 'other',
  clinic = 'clinic',
  parking = 'parking',
  mailbox = 'mail-box',
  convenience_store = 'Convenience Store',
  photo = 'photo',
}

export default place_types;
